import {ProductKeyByHostEnum} from 'presentation/constants';
import {
	ccgData,
	clinipamData,
	gndiMinasData,
	gndiSaoPauloData,
	hapvidaData,
	notredameSaudeData,
} from './products';
import {HostNameProps} from './types';

export const hostNameData: Record<ProductKeyByHostEnum, HostNameProps> = {
	[ProductKeyByHostEnum.GNDI_MINAS]: gndiMinasData,
	[ProductKeyByHostEnum.CLINIPAM]: clinipamData,
	[ProductKeyByHostEnum.HAP]: hapvidaData,
	[ProductKeyByHostEnum.CCG]: ccgData,
	[ProductKeyByHostEnum.GNDI]: gndiSaoPauloData,
	[ProductKeyByHostEnum.NOTREDAME_SAUDE]: notredameSaudeData,
};
